import { render, staticRenderFns } from "./parentchildsongsdetail.vue?vue&type=template&id=17794846&scoped=true"
import script from "./parentchildsongsdetail.vue?vue&type=script&lang=js"
export * from "./parentchildsongsdetail.vue?vue&type=script&lang=js"
import style0 from "./parentchildsongsdetail.vue?vue&type=style&index=0&id=17794846&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17794846",
  null
  
)

export default component.exports